<div class="w-100">
  <cw-tab
    [items]="switchUserTabs"
    selected="offline-customers"
    (tabChange)="onTabChange($event)"
    data-cy="switch-view-sidebar-content-cw-tab">
    <div slot="offline-customers">
      <app-switch-offline-users-tab
        [isActiveTab]="isOfflineCustomersActive()"
        [primaryActionClicked]="primaryActionClicked()"
        (switchView)="reloadPage($event)"
        data-cy="switch-view-sidebar-content-app-switch-offline-users-tab"/>
    </div>
    <div slot="online-customers">
      <app-switch-online-users-tab
        [isActiveTab]="isOnlineCustomersActive()"
        [primaryActionClicked]="primaryActionClicked()"
        (switchView)="reloadPage($event)"
        data-cy="switch-view-sidebar-content-app-switch-online-users-tab"/>
    </div>
  </cw-tab>
</div>
